import { AxiosResponse } from 'axios';

import axios from '../axios';
import { TRIALS_API_ROOT } from '../constants';

type TrialAndSiteInfo = {
  trial: { nct_id: string; short_name: string };
  site: { name: string };
};

export const boxApi = {
  getTrialAndSiteInfo: async (trialId: string, siteId: string): Promise<AxiosResponse<TrialAndSiteInfo>> => {
    return axios.get(`${TRIALS_API_ROOT}/v2/box/getTrialAndSiteInfo/${trialId}/${siteId}`);
  },
  submitActivationPacket: async (trial: string, siteName: string, files: File[]): Promise<AxiosResponse<void>> => {
    const formData = new FormData();
    formData.append('trial', trial);
    formData.append('siteName', siteName);
    files.forEach((file) => formData.append('files', file));
    return axios.post(`${TRIALS_API_ROOT}/v2/box/submitActivationPacket`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  submitRAFPacket: async (trial: string, siteName: string, files: File[]): Promise<AxiosResponse<void>> => {
    const formData = new FormData();
    formData.append('trial', trial);
    formData.append('siteName', siteName);
    files.forEach((file) => formData.append('files', file));
    return axios.post(`${TRIALS_API_ROOT}/v2/box/submitRAFPacket`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};
